import React from "react";
import SunderVideoCard from "./SunderVideoCard";
import SunderSlider from "./SunderSlider";

const SunderNursery = ({ headerData, handleclick, handleShareData }) => {
  const shortsData = headerData?.parikshadata?.shorts;

  return (
    <>
      <section className="sunder_nur_sec">
        <img src="/assets/images/wings.png" className="wing_img_pos" alt="" />
        <div className="container-fluid">
          <div className="sunder_con_pad">
            <div className="sunder_content">
              <h2>{headerData?.title}</h2>
              <p className="sunder_conpa">Watch PM Narendra Modi talk about the importance of managing your time and stress in the latest edition of Praiksha Pe Charcha 2025.</p>
              {headerData && (
                <SunderVideoCard
                  headerData={headerData}
                  handleShareData={handleShareData}
                  type={"long"}
                />
              )}
              {shortsData && (
                <SunderSlider
                  shortsData={shortsData}
                  handleclick={handleclick}
                  handleShareData={handleShareData}
                  type={"shorts"}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SunderNursery;
